import React from 'react';
import { Grid, Box } from '@mui/material';
import { ReactComponent as Weather } from "../../assets/dashboardIcons/WeatherIcon.svg"
import { ReactComponent as Direction } from "../../assets/dashboardIcons/DirectionIcon.svg"
import { ReactComponent as Water } from "../../assets/dashboardIcons/WaterIcon.svg"
import { ReactComponent as Light } from "../../assets/dashboardIcons/LightRainIcon.svg"
import { ReactComponent as Flow } from "../../assets/dashboardIcons/FlowIcon.svg"
import { ReactComponent as Rain } from "../../assets/dashboardIcons/RainIcon.svg"
import { ReactComponent as Sun } from "../../assets/dashboardIcons/SunIcon.svg"

const weatherData = [
    { label: 'Temperatura', value: '-3°', icon: Weather, active: true },
    { label: 'Umidità', value: '-3°', icon: Water, active: true },
    { label: 'Pressione', value: '-3°', icon: Direction, active: true },
    { label: 'Pioggia', value: '-3°', icon: Light, active: false },
    { label: 'Vento', value: '-3°', icon: Flow, active: false },
    { label: 'Punto di rugiada', value: '-3°', icon: Rain, active: false },
    { label: 'Sole', value: '-3°', icon: Sun, active: false }
];

const WeatherCards = () => {
    return (
        <Box className="CondizioniTemperature">
            <p className="sectiontitleSmall">Condizioni meteo previsionali nell’intervallo di tempo selezionato per i vigneti selezionati</p>

            <Box className="CondizioniTemperature__inner">
                {weatherData.map((item, index) => (
                        <Box className="temperaturaBox" key={index}>
                            <Box className="temperaturaBox__top">
                                <Box className="temperaturaBox__icon">
                                    <item.icon />
                                </Box>
                                <h4 style={{ color: "#225CA6" }}>
                                    {item.value}
                                </h4>
                            </Box>
                            <h2 className='temperaturaBox__title' style={{ color: `${item.active}` ? '#225CA6' : '#F9F9F9' }}>
                                {item.label}
                            </h2>
                        </Box>
                ))}
            </Box>
        </Box>
    );
};

export default WeatherCards;
